import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { AddPermitTypeFormInputs } from '@src/permitTypesManager/AddPermitTypeFormInputs';
import {
  AbMVIDNumberField,
  AccountNumbersBilingualField,
  BcCustomerNumberField,
  BcFINNumberField,
  CaNSCField,
  FederalIDNumberField,
  KentuckyNumberField,
  LaNumberField,
  MontanaNumberField,
  NLMasterNumberField,
  OnCVORNumberField,
  OnPRIOAccountNumberField,
  OregonNumberField,
  QcNEQNumberField,
  QcNIRNumberField,
  TennesseeNumberField,
  TexasNumberField,
  UsDotNumberField,
  UsICCField,
  UsIFTAField,
  UsIRPNumberField,
} from '@src/permitTypesManager/permitTypeSections/JurisdictionIdNumberFields';
import { JurisdictionField } from '@src/permitTypesManager/permitTypeSections/PermitDefinitionFields';
import type { SectionField } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { PermitTypeSectionCheckboxList } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const JurisdictionIdNumberSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AddPermitTypeFormInputs>();

  const [permitJurisdiction] = useWatch({
    control,
    name: [JurisdictionField.fieldName],
  });

  const generalFields: SectionField[] = [
    {
      field: AccountNumbersBilingualField,
      label: t('fields.bilingual'),
    },
    {
      field: UsDotNumberField,
      label: t('fields.USDOTNumber'),
    },
    {
      field: FederalIDNumberField,
      label: t('fields.federalIdNumber'),
    },
    {
      field: UsICCField,
      label: t('fields.usICC'),
    },
    {
      field: UsIFTAField,
      label: t('fields.usIFTA'),
    },
    {
      field: UsIRPNumberField,
      label: t('fields.usIRP'),
    },
    {
      field: CaNSCField,
      label: t('fields.caNSC'),
    },
  ];

  const abFields: SectionField[] = [
    {
      field: AbMVIDNumberField,
      label: t('fields.abMVIDNumber'),
    },
  ];

  const bcFields: SectionField[] = [
    {
      field: BcCustomerNumberField,
      label: t('fields.bcCustomerNumber'),
    },
    {
      field: BcFINNumberField,
      label: t('fields.bcFINNumber'),
    },
  ];

  const qcFields: SectionField[] = [
    {
      field: QcNIRNumberField,
      label: t('fields.qcNIRNumber'),
    },
    {
      field: QcNEQNumberField,
      label: t('fields.qcNEQNumber'),
    },
  ];

  const onFields: SectionField[] = [
    {
      field: OnCVORNumberField,
      label: t('fields.onCVORNumber'),
    },
    {
      field: OnPRIOAccountNumberField,
      label: t('fields.onPRIOAccountNumber'),
    },
  ];

  const nlFields: SectionField[] = [
    {
      field: NLMasterNumberField,
      label: t('fields.nlMasterNumber'),
    },
  ];

  const kyFields: SectionField[] = [
    {
      field: KentuckyNumberField,
      label: t('fields.kentuckyNumber'),
    },
  ];

  const laFields: SectionField[] = [
    {
      field: LaNumberField,
      label: t('fields.laNumber'),
    },
  ];

  const mtFields: SectionField[] = [
    {
      field: MontanaNumberField,
      label: t('fields.montanaNumber'),
    },
  ];

  const orFields: SectionField[] = [
    {
      field: OregonNumberField,
      label: t('fields.oregonFileNumber'),
    },
  ];

  const tnFields: SectionField[] = [
    {
      field: TennesseeNumberField,
      label: t('fields.tennesseeNumber'),
    },
  ];

  const txFields: SectionField[] = [
    {
      field: TexasNumberField,
      label: t('fields.texasNumber'),
    },
  ];
  return (
    <Stack direction="column" gap={theme.spacing['1']}>
      <PermitTypeSectionCheckboxList
        sectionFields={generalFields}
        control={control}
      />

      {permitJurisdiction == 'AB' && (
        <PermitTypeSectionCheckboxList
          sectionFields={abFields}
          control={control}
        />
      )}
      {permitJurisdiction == 'BC' && (
        <PermitTypeSectionCheckboxList
          sectionFields={bcFields}
          control={control}
        />
      )}
      {permitJurisdiction == 'QC' && (
        <PermitTypeSectionCheckboxList
          sectionFields={qcFields}
          control={control}
        />
      )}
      {permitJurisdiction == 'ON' && (
        <PermitTypeSectionCheckboxList
          sectionFields={onFields}
          control={control}
        />
      )}
      {permitJurisdiction == 'NL' && (
        <PermitTypeSectionCheckboxList
          sectionFields={nlFields}
          control={control}
        />
      )}
      {permitJurisdiction == 'KY' && (
        <PermitTypeSectionCheckboxList
          sectionFields={kyFields}
          control={control}
        />
      )}
      {permitJurisdiction == 'LA' && (
        <PermitTypeSectionCheckboxList
          sectionFields={laFields}
          control={control}
        />
      )}
      {permitJurisdiction == 'MT' && (
        <PermitTypeSectionCheckboxList
          sectionFields={mtFields}
          control={control}
        />
      )}
      {permitJurisdiction == 'OR' && (
        <PermitTypeSectionCheckboxList
          sectionFields={orFields}
          control={control}
        />
      )}
      {permitJurisdiction == 'TN' && (
        <PermitTypeSectionCheckboxList
          sectionFields={tnFields}
          control={control}
        />
      )}
      {permitJurisdiction == 'TX' && (
        <PermitTypeSectionCheckboxList
          sectionFields={txFields}
          control={control}
        />
      )}
    </Stack>
  );
};
